import React from "react";
import { ChevronDown } from "lucide-react";
import useComponentVisible from "../ComponentVisible";

const DropdownButton = ({ title, buttons }) => {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

    return (
        <div className="inline-flex items-center relative">
            <div className="relative" ref={ref}>
                <button
                    type="button"
                    onClick={() => setIsComponentVisible(!isComponentVisible)}
                    className="stride-filter-button"
                    aria-expanded={isComponentVisible}
                >
                    <span>{title}</span>
                    <ChevronDown size={15} className={`transition-transform duration-150 ${isComponentVisible ? 'rotate-180' : ''}`} />
                </button>
                {isComponentVisible && (
                    <div className="stride-dropdown-menu right-0 min-w-[190px] p-1.5">
                        <ul className="list-none p-0 m-0 space-y-0.5">
                            {buttons?.map((button, index) => (
                                <li key={index}>
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            setIsComponentVisible(false);
                                            button?.onClick?.(e);
                                        }}
                                        className="stride-dropdown-item rounded-lg"
                                    >
                                        {button?.title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DropdownButton;
